module.exports = __webpack_public_path__ + "static/media/terceiro.94275e83.png";